import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import LabelledTextBox from '../../components/LabelledTextBox';
import { updateValveDeficiency } from '../../services/api';
import useAuth from '../../services/authentication/useAuth';
import EventEmitter from '../../services/events';
import { makeValveDeficiency } from '../../models';
import LabelledCheckBox from '../../components/LabelledCheckBox';
import LabelledEditablePicker from '../../components/LabelledEditablePicker';

const DEFAULT_DEFICIENCY_TYPES = [
  'Stuck Valve',
  'Hard to Turn',
  'Leaking Bonnet',
  'Leaking Packing',
  'Broken Box',
  'Cannot Locate'
];

const EditValveDeficiencyModal = ({ open, toggle, onComplete, onCancel, valveDeficiency }) => {
  const { companyId } = useAuth();
  const [valveDeficiencyState, setValveDeficiencyState] = useState(makeValveDeficiency({ ...valveDeficiency, companyId }));

  const save = async () => {
    try {
      valveDeficiencyState.validate();
      const result = await updateValveDeficiency(valveDeficiencyState);
      onComplete(result.id);
    } catch (error) {
      console.log(error);
      if (error.name === 'ValidationError') {
        EventEmitter.emit('show-error', { title: 'Error Saving Valve Deficiency', body: error.message.split('\n').map((str, idx) => <p key={idx}>{str}</p>) });
      } else {
        EventEmitter.emit('show-error', { title: 'Error Saving Valve Deficiency', body: 'Unable to save valve deficiency.' });
      }
    }
  };

  const cancel = async () => {
    onCancel();
    setValveDeficiencyState(makeValveDeficiency({ ...valveDeficiency, companyId }));
  };

  const onChange = e => {
    const type = e.target.type;
    let value = e.target.value;
    switch (type) {
      case 'number':
        value = +value;
        break;
      case 'checkbox':
        value = e.target.checked;
        break;
    }

    setValveDeficiencyState(makeValveDeficiency({ ...valveDeficiencyState, [e.target.name]: value }));
  };

  const onBlur = e => {
    const type = e.target.type;
    let value = e.target.value;
    switch (type) {
      case 'number':
        value = +value;
        break;
      case 'checkbox':
        value = e.target.checked;
        break;
    }

    setValveDeficiencyState(makeValveDeficiency({ ...valveDeficiencyState, [e.target.name]: value }));
  };

  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader>
        <div>Edit Valve Deficiency</div>
      </ModalHeader>
      <ModalBody>
          <div className='details'>
            <LabelledEditablePicker label="Deficiency Type" value={valveDeficiencyState.deficiencyType} name="deficiencyType" onChange={onChange} onBlur={onBlur}>
              {DEFAULT_DEFICIENCY_TYPES.map((type, idx) => (
                <option key={idx} value={type}></option>
              ))}
            </LabelledEditablePicker>
            <LabelledTextBox label="Note" value={valveDeficiencyState.note} name="note" onChange={onChange} onBlur={onBlur} />
            <LabelledCheckBox label="Resolved" value={valveDeficiencyState.resolved} name="resolved" onChange={onChange} onBlur={onBlur} />
          </div>
      </ModalBody>
      <ModalFooter>
        <div className="actions">
          <button type="button" className="btn btn-secondary" onClick={cancel}>Cancel</button>
          <button type="button" className="btn btn-primary" onClick={save}>Save</button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default EditValveDeficiencyModal;